import {
  getStoredEnrollmentLeadContactData,
  getStoredEnrollmentZipCodeWithProfileFallback
} from '../../utils/enrollmentStorageSelectors'
import type { AppointmentContactData } from './types'

export function getZipFromStorage(): string {
  return getStoredEnrollmentZipCodeWithProfileFallback()
}

export function getStoredAppointmentFormData(): AppointmentContactData {
  const storedFormData = getStoredEnrollmentLeadContactData()

  return {
    contactExternalId: storedFormData.contactExternalId || '',
    email: storedFormData.email || '',
    firstName: storedFormData.firstName || '',
    lastName: storedFormData.lastName || '',
    phoneNumber: storedFormData.phoneNumber || storedFormData.phone || ''
  }
}
